export default __webpack_public_path__ + "static/media/screen5.33e6c96d.png";